import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import { TypedMemo } from '../../../common/types';
import { upgradeMessages } from './upgradeMessages';
import styles from './SMLUpgradePromptHead.module.scss';
import { withBrandWord } from '../primitives/BrandWord';

interface SMLUpgradePromptHeadProps {
  /** The tile content: the feature icon (b1) or the quota number (b2). */
  icon: React.ReactNode;
  title: string;
  body: string;
  onClose: () => void;
}

/** Design b's top: the close button, the icon tile, the title and the body. */
const SMLUpgradePromptHeadComponent: React.FC<SMLUpgradePromptHeadProps> = ({ icon, title, body, onClose }) => {
  const intl = useIntl();
  return (
    <>
      <button
        type="button"
        className={styles.close}
        onClick={onClose}
        aria-label={intl.formatMessage(upgradeMessages.close)}
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
      <div className={styles.icon} aria-hidden="true">
        {icon}
      </div>
      <div>
        <h3 className={styles.title}>{withBrandWord(title)}</h3>
        <p className={styles.body}>{withBrandWord(body)}</p>
      </div>
    </>
  );
};

export const SMLUpgradePromptHead = TypedMemo(SMLUpgradePromptHeadComponent);
